import React, { useState, useEffect, useRef, useCallback } from "react";
import ReactTable from "react-table";
import Button from "components/button/Button";
import Pagination from "components/common/Pagination";
import "react-table/react-table.css";
import { withRouter } from "react-router";
import CustomToast from "components/notifications/CustomToast";
import SweetAlert from "react-bootstrap-sweetalert";  
import LoaderComponent from "components/common/LoaderComponent"
let debounceTimer;

const initSnackBar = {
    flag: false,
    heading: '',
    description: ''
}

const UserTable = props => {
    const [snackBar, setSnackBar] = useState(initSnackBar);
    const [tblData, settblData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [pages, setPages] = useState(50);
    const [activePage, setActivePage] = useState(0);
    const [searchText, setSearchText] = useState(null);
    const [sortedId, setSortedId] = useState({ id: null, desc: null });
    const [changeMethodFlag, setChangeMethodFlag] = useState(false);

    const tableRef = useRef();
    const { history } = props;
    
    const formAction = useCallback((action, data = null) => {
        // Here you can view the data and make forward action for edit data
        if (action === "add") {
            history.push("/companies/add");
        } else if (action === "edit") {
            history.push(`/companies/edit/${data._id}`, data);
        }
    }, [history]);




    const columns = React.useMemo(
        () => [
            {
                Header: "Şirket Adı",
                accessor: "name",
                className: "text-center",
                filterable: false,
                headerClassName: "react-table-header-class"
            },
            {
                Header: "Email",
                accessor: "email",
                className: "text-center",
                filterable: false,
                headerClassName: "react-table-header-class"
            },
            {
                Header: "Telefon",
                accessor: "phone_number",
                className: "text-center",
                filterable: false,
                headerClassName: "react-table-header-class"
            },
            {
                Header: "Adres",
                accessor: "address",
                className: "text-center",
                filterable: false,
                headerClassName: "react-table-header-class"
            },
            {
                Header: "Düzenle / Sil",
                accessor: "action",
                className: "text-center",
                headerClassName: "react-table-header-class",
                sortable: false,
                filterable: false,
                width: 250,
                Cell: props => (
                    <div className="react-action-class">
                        <Button
                            className="c-btn c-success mr-10"
                            onClick={() => formAction("edit", props.original)}
                        >
                            <div className="fs-14 medium-text">
                                <i className="fas fa-edit mr-6" /> Düzenle
                            </div>
                        </Button>
                        <Button
                            className="c-btn c-danger"
                            id="delete"
                            onClick={() => deleteClick(props.original)}
                        >
                            <div className="fs-14 medium-text">
                                <i className="fas fa-trash mr-6" /> Sil
                            </div>
                        </Button>
                    </div>
                ) // Custom cell components!
            }
        ],
        [formAction]
    );

    const callSearchApi = useCallback(() => {
        setChangeMethodFlag(changeMethodFlag => !changeMethodFlag)
    }, []);

    useEffect(() => {
        if (searchText !== null) {
            if (debounceTimer) {
                clearTimeout(debounceTimer);
                debounceTimer = null;
            }
            debounceTimer = setTimeout(callSearchApi, 500);
        }
    }, [searchText, callSearchApi]);

    useEffect(() => {
        const params = {
            page: 1,
            sorted: {
                id: null,
                desc: null
            },
            searchText: ""
        }
        callListApi(params)
    }, []);

    const callListApi = (params) => {

        fetch('/service/showcompanies', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(params)
        })
            .then(res => res.json())
            .then(companies => {
                settblData(companies.companies)
                setPages(companies.length)
            })

        // alert("when component mount call api and get first 10 record");
        // When you get data from api add data to state using this method settblData(data)
        // when you call api set loader of table using setLoader(true)
        // when you call api set number of pages using setPages(count)
        //settblData(dummyData);
        setLoader(true);
        setTimeout(() => {
            setLoader(false);
        }, 1000);
    }
    const [basicAlert, setBasicAlert] = useState(false);
    const [deleteRow, setDeleteRow] = useState({});

    const onChangePageGetData = state => {
        if (activePage !== null) {
            const sorted = state.sorted
            if (sorted.length > 0) {
                setSortedId({
                    id: sorted[0].id,
                    desc: sorted[0].desc
                })
            }
            if (state.page !== activePage || searchText !== null || (sorted.length > 0 && (sorted[0].id !== sortedId.id || sorted[0].desc !== sortedId.desc))) {
                const params = {
                    page: state.page + 1,
                    sorted: {
                        id: sorted.length > 0 ? sorted[0].id : null,
                        desc: sorted.length > 0 ? sorted[0].desc : null
                    },
                    searchText: searchText
                }
                callListApi(params)
            }
        }
    };

    const deleteClick = data => {
        // console.log('tblData', tableRef.current.state.data)
        // console.log('activePgae', tableRef.current.state.page)
        // Here you can view the data and delete through API calling
        setDeleteRow(data);
        setBasicAlert(true);
    };
    const deleteOk = () => {
        var data = deleteRow;
        fetch(`/service/companies/${data._id}`, {
            method: 'DELETE',
            body: JSON.stringify(data),
        })
        .then(res => res.json())
        .then(companies => {
            settblData(companies.companies)
            setPages(companies.length)
        })
    };

    return (
        <div>
            <div className="plr-15">
                <div className="roe-card-style mtb-15">
                    <div className="roe-card-header module-header">
                        <div className="flex-1 fs-16 demi-bold-text">
                            <span className="hash"># </span> Şirket Listesi
                        </div>
                        <div className="mr-10">
                            <input
                                value={searchText ? searchText : ""}
                                onChange={e => setSearchText(e.target.value)}
                                type="text"
                                placeholder="Ara..."
                                className="fs-14 medium-text plr-10 form-control react-form-input"
                            />
                        </div>
                        <div>
                            <Button
                                className="c-btn ma-5"
                                onClick={() => formAction("add")}
                                style={{
                                    backgroundColor: 'rgb(255,9,39)',
                                    color: '#fff'
                                }}
                            >
                                <i className="fas fa-plus mr-10"></i>Şirket Ekle
                            </Button>
                        </div>
                    </div>
                    <div className="roe-card-body">
                        <ReactTable
                            style={{
                                border: "none",
                                boxShadow: "none"
                            }}
                            ref={tableRef}
                            data={tblData}
                            columns={columns}
                            defaultPageSize={10}
                            filterable
                            manual
                            className="-striped -highlight custom-react-table-theme-class"
                            pages={pages}
                            page={activePage}
                            PaginationComponent={Pagination}
                            LoadingComponent={LoaderComponent}
                            loading={loader}
                            onFetchData={onChangePageGetData}
                            onPageChange={pageIndex => setActivePage(pageIndex)}
                            changeMethodFlag={changeMethodFlag}
                        />
                    </div>
                    <CustomToast
                        heading={snackBar.heading}
                        width={400}
                        show={snackBar.flag}
                        transition
                        position="top-middle"
                        className="c-success"
                        message={snackBar.description}
                        onCloseCLick={() =>
                            setSnackBar(initSnackBar)
                        }
                    />
                </div>
            </div>
            <SweetAlert
                warning
                showCancel
                show={basicAlert}
                confirmBtnBsStyle="danger"
                confirmBtnText="Evet, Sil"
                cancelBtnText="Hayır"
                title={`${deleteRow.name} adlı şirketi silmek istiyor musunuz?`}
                onConfirm={() => {
                    setBasicAlert(!basicAlert)
                    deleteOk();
                }}
                onCancel={() => setBasicAlert(!basicAlert)}
                focusCancelBtn
                confirmBtnCssClass="sweet-alert-confirm-button"
                cancelBtnCssClass="sweet-alert-cancle-button"
            />
        </div>
    );
};

export default withRouter(UserTable);
